import React from 'react';
import { renderToString } from 'react-dom/server';

import { CommentAltIcon } from '../../../icon/regular';
import {
  BaseSaveInstructionData,
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import InlineInstruction from '../base-instruction/InlineInstruction';
import { addInstructionEvent, emitInstructionEvent } from '../utils';

class TextInstruction extends InlineInstruction {
  protected static title = 'Text overlay';

  get icon() {
    return renderToString(<CommentAltIcon style={{ height: 20 }} />);
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.TEXT_INSTRUCTION_WRAPPER,
      content: InstructionCSSClasses.TEXT_INSTRUCTION_CONTENT,
      action: InstructionCSSClasses.TEXT_INSTRUCTION_ACTION,
    };
  }

  openModal(instructionId: string): void {
    this.initEvents();
    let text = '';
    if (this.range) {
      text = this.range.cloneContents().textContent || '';
    }
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_TEXT_INSTRUCTION_MODAL,
      { instructionId, text, isInline: true },
    );
  }

  getTooltip(tooltip: string): string {
    return `${InstructionActionTooltip.text}: ${tooltip}`;
  }

  initEvents() {
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_TEXT_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SET_TEXT_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  removeEvents() {
    this.api.events.off(
      InstructionEvent.SAVE_TEXT_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    this.api.events.off(
      InstructionEvent.SET_TEXT_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  saveInstruction(data: BaseSaveInstructionData) {
    if (!this.isActive) {
      this.wrap(data);
    }
    this.removeEvents();
  }

  cancel() {
    this.setSelection();
    this.removeEvents();
  }
}

export default TextInstruction;
